import { Stack } from 'react-bootstrap';

import InfoDialog from '@components/Modals/InfoDialog';
import { ResultTypeLegend } from '@components/results';

interface IProps {
  onClose: () => void;
}

export default function OrderInfoDialog({ onClose }: IProps) {
  return (
    <InfoDialog
      onClose={onClose}
      title='Orders and Reports'
      modalProps={{
        id: 'orderInfoDialog',
        className: 'order-info-dialog',
      }}
    >
      <Stack gap={2} className='p-3 pt-2'>
        <p className='fs-6 fw-bold lh-base mb-0'>Each order is associated with one or more reports.</p>
        <div className='fs-sm ms-3'>
          <p className='mt-1 mb-0'>An order&apos;s status can be:</p>
          <ul className='mb-0 order-status-list'>
            <li>Awaiting Sample</li>
            <li>Analyzing</li>
            <li>Reported</li>
            <li>Canceled</li>
          </ul>
        </div>

        <div className='fs-sm ms-3'>
          <p className='mb-0 fw-bold'>Results Report†</p>

          <ResultTypeLegend />
        </div>

        <p className='mb-0 fs-xs ms-3'>†Not applicable to the Pharmacogenomics Report.</p>

        <p className='fs-6 fw-bold lh-base mb-0'>Patient Packet</p>
        <p className='mb-0 fs-sm ms-3'>
          When an order is completed, the Patient Packet will become available to download. The Patient Packet includes
          all reports and supplemental materials for an order.
        </p>
      </Stack>
    </InfoDialog>
  );
}
